var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_98305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15991 7.80005V12.28",
    stroke: "#868FA0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15994 5.39996C8.69566 5.39996 9.12994 4.96568 9.12994 4.42996C9.12994 3.89424 8.69566 3.45996 8.15994 3.45996C7.62422 3.45996 7.18994 3.89424 7.18994 4.42996C7.18994 4.96568 7.62422 5.39996 8.15994 5.39996Z",
    fill: "#868FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49 12.83V10.04C1.49 8.93 1.11 8.64 0 8.64V7.36C1.11 7.36 1.49 7.08 1.49 5.96V3.17C1.49 0.91 2.36 0 4.28 0H5.4V1.3H4.61C3.46 1.3 3.08 1.75 3.08 3.11V5.81C3.08 7.02 2.7 7.75 1.87 7.98V8.02C2.7 8.27 3.08 8.98 3.08 10.19V12.89C3.08 14.25 3.46 14.7 4.61 14.7H5.4V16H4.28C2.36 16.01 1.49 15.1 1.49 12.83Z",
    fill: "#868FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5801 14.7H11.3701C12.5201 14.7 12.9001 14.25 12.9001 12.89V10.19C12.9001 8.98 13.2801 8.26 14.1101 8.02V7.98C13.2801 7.75 12.9001 7.02 12.9001 5.81V3.11C12.9001 1.75 12.5201 1.3 11.3701 1.3H10.5801V0H11.6901C13.6201 0 14.4801 0.91 14.4801 3.17V5.96C14.4801 7.07 14.8601 7.36 15.9701 7.36V8.64C14.8601 8.64 14.4801 8.92 14.4801 10.04V12.83C14.4801 15.1 13.6101 16 11.6901 16H10.5801V14.7Z",
    fill: "#868FA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_98305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.75a1554c.svg";
export { ForwardRef as ReactComponent };